import React from 'react';
import { cmsLinkProps } from '../propTypes';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ExternalLink = ({href, onClick, className, activeClass, target = '_blank', useIcon = false, ...props}) => (
    <a href={href} target={target} onClick={onClick} className={`${className} ${activeClass}`}>
        <span>{ props.children }</span>
        { useIcon ? <FontAwesomeIcon icon={['fas', 'external-link']}/> : null }
    </a>
);

ExternalLink.propTypes = cmsLinkProps;

export default ExternalLink;


